
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2020-10-12-typography-utterance",
      function () {
        return require("private-next-pages/blogs/2020-10-12-typography-utterance/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2020-10-12-typography-utterance"])
      });
    }
  